var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"px-3 marquee-container"},[_c('i',{staticClass:"fas fa-volume-up my-auto pr-3 marquee-icon"}),_c('NoticeBar',{staticClass:"notice-bar px-0",attrs:{"scrollable":"","speed":_vm.speed,"text":_vm.text}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }